export const productLinks = [
  // Temporarily hidden — retain the product configuration for its return.
  // {
  //   id: 'workspace',
  //   href: 'https://drct-landing.netlify.app/products/bt',
  //   titleKey: 'productsMenu.workspace.title',
  //   descriptionKey: 'productsMenu.workspace.description',
  //   iconKey: 'desktop',
  // },
  {
    id: 'extension',
    href: '/extension',
    titleKey: 'productsMenu.extension.title',
    descriptionKey: 'productsMenu.extension.description',
    iconKey: 'desktop',
  },
  {
    id: 'api',
    href: '/developers',
    titleKey: 'productsMenu.api.title',
    descriptionKey: 'productsMenu.api.description',
    iconKey: 'codeSimple',
  },
];
